import partnerCategoriesRepository from '@/repository/generatedRepository/partnerCategoriesRepository'

const state = {
  list: [],
}

const getters = {
  list: state => state.list,
}

const actions = {
  async loadData(context) {
    const { data } = await partnerCategoriesRepository.list({ pagination: { limit: -1 } })
    const items = data.items || data
    context.commit('setList', items)
    return items
  },
  async loadItem(context, id) {
    const { data } = await partnerCategoriesRepository.get(id)
    return data
  },
  saveRanges(context, payload) {
    const { id, ranges } = payload
    return partnerCategoriesRepository.saveRanges(id, { ranges })
  },
}

const mutations = {
  setList(state, list) {
    state.list = [...list]
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
